import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'

import { CalendarConnectionsView } from './calendars/CalendarConnectionsView'
import { AppointmentsListView } from './appointments/AppointmentsListView'

type CalSubView = 'connections' | 'appointments'

function isSubView(v: string | null): v is CalSubView {
  return v === 'connections' || v === 'appointments'
}

export function CalendarsView() {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()

  const raw = searchParams.get('calView')
  const subView: CalSubView = isSubView(raw) ? raw : 'connections'

  const setSubView = (next: CalSubView) => {
    const params = new URLSearchParams(searchParams)
    if (next === 'connections') {
      params.delete('calView')
    } else {
      params.set('calView', next)
    }
    setSearchParams(params, { replace: true })
  }

  const tabs: { key: CalSubView; label: string }[] = [
    { key: 'connections', label: t('manager.tabs.calendars') },
    { key: 'appointments', label: t('manager.tabs.appointments') },
  ]

  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 min-h-0 overflow-y-auto">
        <div className="px-6 lg:px-8 py-6 space-y-4 sm:space-y-6">
          {/* Bandeau de sous-onglets */}
          <div className="flex bg-slate-100 dark:bg-slate-900/50 p-1 rounded-lg w-fit">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setSubView(tab.key)}
                className={`px-4 py-1.5 text-sm font-medium rounded-md transition-all ${
                  subView === tab.key
                    ? 'bg-white dark:bg-slate-700 text-slate-900 dark:text-white shadow-sm'
                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {subView === 'connections' ? (
            <CalendarConnectionsView />
          ) : (
            <AppointmentsListView />
          )}
        </div>
      </div>
    </div>
  )
}
